import { Button } from '@creditornot/cb-button';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { ModalHeader, ModalFooter } from '@creditornot/cbt-modal';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { WoltModal } from 'common/components';
import { Typography as T } from 'common/typography';

type Props = {
  contentName: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const StyledWoltModal = styled(WoltModal)`
  width: 100%;
  max-width: 540px;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  background: ${cbSemanticCssVars.surfaceMain};
`;

const ModalTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-block-start: 1px solid ${cbSemanticCssVars.borderPrimary};
`;

const StyledModalFooter = styled(ModalFooter)`
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
`;

const ActionButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 8px;
`;

export const CommissionConfirmationModal: React.FC<Props> = ({ contentName, isOpen, onClose, onConfirm }) => {
  return (
    <StyledWoltModal isOpen={isOpen}>
      <ModalHeader onCloseClick={onClose}>
        <FormattedMessage id="menu-item.commissions-modal.title" />
      </ModalHeader>
      <ModalBody>
        <ModalTextContainer>
          <p>
            <T.Body3>
              <FormattedMessage
                id="menu-item.commissions-modal.item-question"
                values={{
                  contentName,
                  bold: chunks => <b>{chunks}</b>,
                }}
              />
            </T.Body3>
          </p>
          <p>
            <T.Body3>
              <FormattedMessage id="menu-item.commissions-modal.info-about-send-email" />
            </T.Body3>
          </p>
        </ModalTextContainer>
      </ModalBody>
      <StyledModalFooter>
        <ActionButtons>
          <Button size="small" variant="secondary" onClick={onClose}>
            <FormattedMessage id="menu-item.commissions-modal.cancel" />
          </Button>
          <Button size="small" variant="primary" onClick={onConfirm}>
            <FormattedMessage id="menu-item.commissions-modal.update" />
          </Button>
        </ActionButtons>
      </StyledModalFooter>
    </StyledWoltModal>
  );
};
